<template>
  <div class="form-group" :class="{ error: hasErrors }">
    <slot/>
    <div class="errors form-text" v-if="hasErrors">
      <div class="text-danger" v-for="error in activeErrorMessages">{{ error }}</div>
    </div>
  </div>
</template>

<script>
  import { singleErrorExtractorMixin } from 'vuelidate-error-extractor'

  export default {
    mixins: [singleErrorExtractorMixin]
  }
</script>